/**
 * Parses a JWT & extracts all wanted information (user details, properties list)
 * @param  {string} token - an encoded JWT
 * @return {object} an object containing: userInfo, token, preferences
 */
const parseUserToken = (token) => {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    const {
        account: { id: userId, uuid, firstName, lastName, email, locale },
        preferences,
    } = decoded.scope;

    return {
        userInfo: {
            userId,
            uuid,
            firstName,
            lastName,
            email,
            locale,
        },
        preferences: preferences || {},
        token,
    };
};

/**
 * Parses the list of authorised properties into an object so properties can be accessed by id (key)
 * @param  {object[]} properties - list of properties as returned by API
 * @return {object} an object containing all properties with their id as a key
 */
const parseUserProperties = (properties) =>
    properties.reduce(
        (accu, property) => ({
            ...accu,
            [property.id]: property,
        }),
        {},
    );

export { parseUserToken, parseUserProperties };
